/**
 * this create video swap
 */
import $ from 'jquery';

export	function initializeFeatureVideo(){
	
    if($(".video-snippet").length >0){
	$(".video-snippet:first-child").addClass("selected");
        $(".video-snippet" ).on('click' ,function() {
	    $(".video-snippet:first-child").removeClass("selected");
            $(".video-snippet").removeClass("selected");
            var id = $(this).attr('video_id');
            renderPlayer(id,'video');
            $(".featured_video_wrapper .video-title").html($(this).find(".thumbnails-text").html());
            $(".featured_video_wrapper .video_description").html($(this).find(".video_description").html());

            $(this).addClass("selected");
        });
    }

    function renderPlayer(vid, mod){
        if(mod=='video'){
            mobilerider.embedVideo(2195, vid ,'video_player', '100%', '100%', 'universal', {extras:"skin:sting,autoplay:0,vs:0,muteOn:0",service:1});

        }else{
            mobilerider.embedVideo(2195,vid,"videoPlayer","640","360","universal",{extras:"skin:sting,autoplay:0,vs:0,muteOn:0",service:1});
        }
    }
}
